import Select from "react-select";
import React, { useContext, useRef } from "react";
import SikkaSelectTheme from "./SikkaSelectTheme";
import AppContext from "../../../context/Context";

const SikkaSelect = (props) => {
  const { isDark } = useContext(AppContext);
  const portalStyle = {
    ...props.styles,
    menuPortal: (base) => ({ ...base, zIndex: 100001 })
  };
  return <Select {...props} styles={isDark ? SikkaSelectTheme : portalStyle} menuPortalTarget={document.body}/>;
};
export default SikkaSelect;
